import Loadable from 'react-loadable';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "app-landing" */ './AsyncAppLandingRoute.js'),
  loading: () => null
});
